import React, { useState } from "react";
import Slider from "../slider/slider";

import time from "../../images/time-management.png";
import quality from "../../images/high-quality.png";
import customer from "../../images/customer.png";
import innovation from "../../images/innovation.png";
import makeitwork from "../../images/flash.png";

import installation from "../../images/installationsbild.jpg";
import beleuchtung from "../../images/beleuchtung1.jpg";
import photov from "../../images/photovolatik.jpg";
import planung from "../../images/planung.jpg";
import schrank from "../../images/schrank2.jpg";
import glasfaser from "../../images/glasfaser.svg"

import video from "../../images/windrad.gif";

import "./dienstleistungen.css";

const merkmale = [
  {
    className: "mz-1",
    image: customer,
    text: "Verbindungen, die begeistern!",
  },
  {
    className: "mz-2",
    image: quality,
    text: "Elektrifizierte Qualität!",
  },
  {
    className: "mz-3",
    image: time,
    text: "Pünktliche Lösungen!",
  },
  {
    className: "mz-4",
    image: innovation,
    text: "Elektrik mit Innovation!",
  },
  {
    className: "mz-5",
    image: makeitwork,
    text: "Immer in Betrieb!",
  },
];

const services = [
  {
    id: 1,
    buttonText: "Elektroinstallationen",
    title: "Elektroinstallationen",
    list: [
      "Schaltschrankbau",
      "Zählerschranke",
      "elektrischer Anschluss von Wärmepumpen",
    ],
    content: <img id="image" src={installation} alt="installation" />,
  },
  {
    id: 2,
    buttonText: "Beleuchtungen",
    title: "Beleuchtungen",
    list: ["Hängeleuchten", "Einbauspots", "Led Stripe"],
    content: <img id="image" src={beleuchtung} alt="beleuchtung" />,
  },
  {
    id: 3,
    buttonText: "Smarthome",
    title: "Smarthome (Homematic IP)",
    list: ["Funktechnik", "Bustechnik"],
    content: <Slider />,
  },
  {
    id: 4,
    buttonText: "Netzwerktechnik",
    title: "Netzwerktechnik",
    list: ["Video- und Sprechanlagen", "Netzwerkverteilungen"],
    content: <img id="image" src={schrank} alt="schrank" />,
  },
  {
    id: 5,
    buttonText: "Erneuerbare Energie + Nutzung",
    title: "Erneuerbare Energie + Nutzung",
    list: ["Photovoltaikanlagen", "Wallbox Installation", "Dach-Windkrafträder"],
    content: (
      <>
        <img id="image" src={photov} alt="photov" />
        <img id="gif" src={video} alt="gif" />
      </>
    ),
  },
  {
    id: 6,
    buttonText: "Glasfaser Ausbau FTTH",
    title: "Glasfaser Ausbau FTTH",
    list: [
      "Hausanschluss für Glasfaser (FTTH)",
      "Verlegung von Glasfaserkabeln im Gebäude",
      "Installation von Netzabschlusspunkten (ONT)",
      "Spleissen und Messen von Glasfaserleitungen",
      "Vorbereitung für Highspeed-Internet (Gigabit)",
      "Integration ins bestehende Heimnetzwerk",
      "Inbetriebnahme und Funktionsprüfung",
      "Beratung und Planung von FTTH-Anschlüssen",
      "Fehlerbehebung bei bestehenden FTTH-Anschlüssen",
    ],
    content: <img id="image" src={glasfaser} alt="" />,
  },
  {
    id: 7,
    buttonText: "Sonstiges",
    title: "Sonstiges",
    list: [
      "Elektrische Planung",
      "Anmeldung/Abmeldung beim Netzbetreiber",
      "Inbetriebnahme elektrischer Anlagen",
      "Fehlersuche",
    ],
    content: <img id="image" src={planung} alt="" />,
  },
];

const Dienstleistungen = () => {
  const [toggle, setToggle] = useState(1);
  const [selectedButton, setSelectedButton] = useState(1);

  function updateToggle(id) {
    setToggle(id);
    setSelectedButton(id);
  }

  return (
    <div>
      <h1>Dienstleistungen</h1>

      <div className="mz-container">
        {merkmale.map((merkmal) => (
          <div className={`mz-item ${merkmal.className}`} key={merkmal.className}>
            <div className="picContainer">
              <img src={merkmal.image} alt="innovation" />
            </div>
            <div className="textContainer">
              <p>{merkmal.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="dienstleistungen">
        <h1>Unser Service</h1>

        <div className="buttons">
          {services.map((service) => (
            <button
              key={service.id}
              className={selectedButton === service.id ? "active" : ""}
              onClick={() => updateToggle(service.id)}
            >
              {service.buttonText}
            </button>
          ))}
        </div>

        {services.map((service) => (
          <div
            key={service.id}
            className={toggle === service.id ? "show-content" : "hide-content"}
          >
            <div className="over-container">
              <div className="list">
                <h2>{service.title}</h2>
                <ul className="service-list">
                  {service.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="img-container">{service.content}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dienstleistungen;
